<template>
    <div>
        <vue2-editor
            :value="value"
            v-validate="'required'"
            :placeholder="placeholder"
            name="content"
            :data-vv-as="placeholder"
            useCustomImageHandler
            @image-added="handleImageAdded"
            @input="onChange"
            :editorOptions="editorOptions"
        />
        <div v-show="errors.has('content')" class="validation-message text-danger">
            Nội dung là trường bắt buộc
        </div>
    </div>
</template>
<script>
import API_CONFIG from '@/api-config';
import { mapActions } from 'vuex';

const editorOptions = {
    modules: {
        toolbar: {
            container: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ['bold', 'italic', 'underline'],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ color: [] }, { background: [] }],
                ['link', 'image']
            ]
        }
    }
};

export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: ['placeholder', 'value'],
    data() {
        return {
            API_CONFIG
        };
    },
    computed: { editorOptions: () => editorOptions },
    methods: {
        ...mapActions({
            uploadImage: 'news/uploadImage'
        }),
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            const formData = new FormData();
            formData.append('file', file);
            this.uploadImage(formData)
                .then((result) => {
                    const url = result.url;
                    Editor.insertEmbed(cursorLocation, 'image', `${API_CONFIG.URL_GET_FILE}${url}`);
                    resetUploader();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onChange(value) {
            this.$emit('change', value);
        }
    }
};
</script>
<style lang="scss">
.quillWrapper .ql-toolbar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;
}
</style>